<script lang="ts">
  import { onMount } from 'svelte'
  import { currentRoute, navigate } from './lib/router'
  import { getToken, getUserType } from './lib/api'
  import Layout from './components/Layout.svelte'
  import Login from './pages/Login.svelte'
  import Sessions from './pages/Sessions.svelte'
  import Messages from './pages/Messages.svelte'
  import SessionPools from './pages/SessionPools.svelte'

  import AdminSessions from './pages/admin/Sessions.svelte'
  import ClientUsers from './pages/admin/ClientUsers.svelte'
  import ExternalAppUsers from './pages/admin/ExternalAppUsers.svelte'
  import Config from './pages/admin/Config.svelte'
  import BotRegistrations from './pages/BotRegistrations.svelte'
  import Toast from './components/ui/Toast.svelte'

  let route = '/'
  
  currentRoute.subscribe(value => {
    route = value || '/'
  })

  // Rutas que requieren permisos de admin
  const adminRoutes = ['/admin/sessions', '/admin/users/clients', '/admin/users/external-apps', '/admin/config']

  // Verificar si la ruta actual requiere permisos de admin
  $: isAdminRoute = adminRoutes.includes(route)
  $: userType = getUserType()
  $: isAdmin = userType === 'admin'

  // Redirigir si un usuario no admin intenta acceder a rutas de admin
  $: {
    if (route !== '/login' && getToken() && isAdminRoute && !isAdmin) {
      navigate('/sessions')
    }
  }

  onMount(() => {
    // Sincronizar ruta actual con el router al montar (para cuando se refresca la página)
    if (typeof window !== 'undefined') {
      const currentPath = window.location.pathname
      let normalizedPath = currentPath
      
      // Normalizar ruta (remover /ui/ si está presente)
      if (currentPath.startsWith('/ui/')) {
        normalizedPath = currentPath.slice(4) || '/'
      } else if (currentPath === '/ui') {
        normalizedPath = '/'
      }
      
      // Actualizar el router con la ruta actual (fuerza sincronización)
      currentRoute.set(normalizedPath)
    }
    
    // Redirect to login if not authenticated (después de sincronizar ruta)
    if (!getToken() && route !== '/login') {
      navigate('/login')
    }
  })
</script>

<div class="bg-gray-900 min-h-screen text-white font-sans selection:bg-emerald-500 selection:text-white">
  <Toast />
  {#if route === '/login'}
    <Login />
  {:else}
    <Layout>
      {#if route === '/sessions' || route === '/'}
        <Sessions />
      {:else if route === '/messages'}
        <Messages />
      {:else if route === '/pools'}
        <SessionPools />
      {:else if route === '/admin/sessions' && isAdmin}
        <AdminSessions />
      {:else if route === '/admin/users/clients' && isAdmin}
        <ClientUsers />
      {:else if route === '/admin/users/external-apps' && isAdmin}
        <ExternalAppUsers />
      {:else if route === '/admin/config' && isAdmin}
        <Config />
      {:else if route === '/bot-registrations'}
        <BotRegistrations />
      {:else}
        <Sessions />
      {/if}
    </Layout>
  {/if}
</div>

<style :global>
  body {
    margin: 0;
    background-color: #111827;
    min-height: 100vh;
  }
  
  html {
    background-color: #111827;
  }
</style>
